import React from "react";

import {
  Menu,
  MenuItem,
  ListItemIcon,
} from "@mui/material";
import {
  OpenInNew,
} from "@mui/icons-material";

import { Visibility, } from "@mui/icons-material";
import { useUser } from "../../hooks/Authorize";
// import { useTheme } from "@emotion/react";

function OpenWithSubMenu({ setAnchorEl, anchorElSubMenu, handleSubMenuClose, currentMenuClickedItem, handleDoubleClickFilePreview }) {
  const platformUser = JSON.parse(localStorage.getItem("user"));
    // const { mode } = useTheme();

  return (
    <Menu
      anchorEl={anchorElSubMenu}
      open={Boolean(anchorElSubMenu)}
      onClose={handleSubMenuClose}
      anchorOrigin={{ vertical: "top", horizontal: "left" }} // Attach to left side
      transformOrigin={{ vertical: "top", horizontal: "right" }} // Expand from right side
      PaperProps={{
        sx: {
          width: "180px",
          borderRadius: "8px",
          padding: "4px 0",
          // background: 'rgba(31, 31, 31, 1)',
          // boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
          // color: "#fff",
          boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",  
          // background: mode === 'dark' ? "rgba(31, 31, 31, 1)" : "rgb(255, 255, 255)",
          mt: -1,
          ml: `-${20}px`, // Dynamically shift left
        },
      }}
      MenuProps={{
        disableAutoFocusItem: true,
        PopperProps: {
          modifiers: [
            {
              name: "preventOverflow",
              options: {
                boundary: "window", // Ensure it doesn't go outside the viewport
              },
            },
            {
              name: "flip",
              enabled: true,
            },
            {
              name: "offset",
              options: {
                offset: [-0, 0], // Move further left (Increase negative value)
              },
            },
          ],
        },
      }}
    >

      <MenuItem sx={{ height: '41px', padding: "12px 16px", }}

        onClick={() => {
          handleSubMenuClose()
          setAnchorEl(null)
          handleDoubleClickFilePreview(currentMenuClickedItem);
        }}
      >
        <ListItemIcon sx={{   }}>
          <Visibility fontSize="small" />
        </ListItemIcon>
        Preview
      </MenuItem>
      <MenuItem sx={{ height: '41px', padding: "12px 16px", }}

        onClick={() => {
          handleSubMenuClose()
          setAnchorEl(null)
          var fileId = currentMenuClickedItem._id;
          var userId = platformUser._id;
            
          // var url = `http://localhost:3000/file?userId=${userId}&fileId=${fileId}`
          var url = `${window.location.origin}/file/${fileId}/${userId}?fileName=${currentMenuClickedItem.name}`
          window.open(
            url,
            '_blank',
            'noopener,noreferrer'
          );
        }}
      >
        <ListItemIcon sx={{   }}>
          <OpenInNew fontSize="small" />
        </ListItemIcon>
        Open in new tab
      </MenuItem>
    </Menu>
  )
}

export default OpenWithSubMenu